import { getCoreDataSecurityMonitorsAllSlice } from './get';

export const { requestGetCoreDataSecurityMonitorsAll, resetGetCoreDataSecurityMonitorsAll } =
    getCoreDataSecurityMonitorsAllSlice.asyncActionCreators;
